var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#FF0000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1394_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00391 14C6.05691 14 3.55597 13.97 2.54297 13.913C1.61497 13.849 1.12871 13.7321 0.678711 12.9351C0.228711 12.1381 0 10.735 0 8.50696V8.49695C0 6.23695 0.208711 4.86904 0.678711 4.06104C1.11271 3.29404 1.58392 3.14704 2.54492 3.09204C3.56592 3.02404 6.12391 3 8.00391 3C9.88391 3 12.435 3.02404 13.458 3.09204C14.419 3.14704 14.8913 3.29204 15.3203 4.06104C15.7913 4.86104 16.001 6.22802 16.001 8.49902V8.50598C16.001 10.778 15.7923 12.145 15.3223 12.937C14.8923 13.699 14.422 13.849 13.458 13.913C12.448 13.969 9.94991 14 8.00391 14ZM6.00391 5.5V11.5L11 8.5L6.00391 5.5Z",
    fill: "red"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1394_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fe61f7c8e499e4622cd1826e374e6f16.svg";
export { ForwardRef as ReactComponent };